import axios from 'axios';
import { encryptAES } from 'utils/generalUtils';
import { convertPassword, decryptStorage, encryptStorage, getDocumentNumber, getExpiresIn, getName, getTimeSession, getTypeDocument } from 'utils/utils';
import { API_URL, URL_CAPTCHA, captchakey, secret, secret_security } from '../../config/config.json';

export async function setLogin(data) {
  const dataToSend = {
    username: data.username,
    password: await convertPassword(data.password)
  };
  return await axios.post(`${API_URL}/login`, dataToSend).then(async res => {
    if (!res.data.data.error) {
      const sessionRes = await setSession(res.data.data)
      if (sessionRes.status === 'success') {
        localStorage.removeItem('logoutType');
        return { data: res.data.data, status: 'success' }
      } else {
        throw ({ message: "token no encontrado" })
      }
    } else {
      const data = res.data.data;
      if (data.email && data.daysTemp) {
        throw ({ message: data.error, data: { email: data.email, daysTemp: data.daysTemp } })
      } else {
        throw ({ message: data.error })
      }
    }
  }).catch(err => {
    if (err.data) {
      return { data: { message: err.message, data: err.data }, status: 'error' }
    }
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function setCaptcha(data) {
  data.url = `${URL_CAPTCHA}?secret=${captchakey}&response=${data.value}`; 
  return await axios.post(`${API_URL}/verify-captcha`, data).then(async res => {
    if (res.data.data.success == true) {
      return { data: res.data.data, status: 'success' }
    } else throw ({ message: "respuesta erronea" })
  }).catch(err => {
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function getVersion() {
  return await axios.get(`${API_URL}/version-consult`).then(res => {
    localStorage.setItem("version", res.data.data.version)
    return { data: { version: res.data.data.version }, status: 'success' }
  }).catch(err => {
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function refreshToken() {
  console.log("Ejecucion de refreshToken");
  const headers = { Authorization: `Bearer ${decryptStorage(localStorage.getItem("tokenSecurity"))}` };

  return await axios.post(`${API_URL}/refresh-token-security`,
    { "username": localStorage.getItem("user"), refreshToken: decryptStorage(localStorage.getItem("refreshToken")) },
    { headers }).then(async res => {
      if (!res.data.data.error) {
        await setSessionSecurity(res.data.data)
        // Guardar la hora exacta en localStorage
        const exactTime = new Date().getTime(); // Obtener la hora exacta en milisegundos
        const exactTimeMoreAdditional = exactTime + 6000; // Agregar milisegundos
        localStorage.setItem("exactTime", exactTimeMoreAdditional.toString());
        const channel = new BroadcastChannel('shared-channel');
        channel.postMessage('updatedExactTime');
        // Guardar la hora exacta en localStorage
        return { data: await getTimeSession(res.data.data.token, secret_security), status: 'success' }
      } else throw ({ message: res.data.data.error })
    }).catch(err => {
      if (err.response && err.response.data) {
        return {
          data: {
            message: err?.response?.data?.data?.error?.information || err?.response?.data?.data?.error || err.message,
            informationCode: err?.response?.data?.data?.error?.informationCode || "401"
          },
          status: 'error'
        }
      }
      else {  
        return { data: { message: err.message }, status: 'error' }
      }
    })
}

export async function closeSession() {
  const headers = { Authorization: `Bearer ${localStorage.getItem("token")}` };
  return await axios.post(`${API_URL}/logout-security`,
    { "username": localStorage.getItem("user"), refreshToken: decryptStorage(localStorage.getItem("refreshToken")) },
    { headers }).then(res => {
      return { status: 'success' }
    }).catch(err => {
      return { data: { message: err.message }, status: 'error' }
    })
}

const setSession = async (data) => {
  const { userName, jwt, role } = data
  if (jwt) {
    localStorage.setItem('token', jwt);
    localStorage.setItem('time', await getTimeSession(jwt, secret))
    localStorage.setItem('timeSesion', await getExpiresIn(jwt, secret))
    localStorage.setItem('documentNumber',await getDocumentNumber(jwt,secret))
    localStorage.setItem('typeDocument', await getTypeDocument(jwt,secret))
    localStorage.setItem('name',await getName(jwt,secret))
    localStorage.setItem('user', userName)
    localStorage.setItem('role', role)
    return { status: 'success' }
  } else {
    localStorage.clear();
    return { status: 'error' }
  }
};

export async function setForgetPassword(data) {
  return await axios.post(`${API_URL}/forget-password`, data).then(async res => {
    if (!res.data.data.error) {
      return { data: { message: res.data.data.message, status: 'success' }, status: 'success' }
    } else throw ({ message: res.data.data.error, status: 'error' })
  }).catch(err => {
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function setChangePassword(data) {
  return await axios.post(`${API_URL}/change-password`, data).then(async res => {
    if (!res.data.data.error) {
      return { data: { message: res.data.data.message, status: 'success' }, status: 'success' }
    } else throw ({ message: res.data.data.error, status: 'error' })
  }).catch(err => {
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function validateTokenChangePassword(data) {
  return await axios.post(`${API_URL}/validate-token-change-password`, data).then(async res => {
    if (!res.data.data.error) {
      return { data: { message: res.data.data.message, status: 'success' }, status: 'success' }
    } else throw ({ message: res.data.data.error, status: 'error' })
  }).catch(err => {
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function structureRolesAndPrivilegesApi(data) {
  return await axios.post(`${API_URL}/structure-roles-privileges`, data).then(async res => {
    if (!res.data.data.error) {
      return { data: res.data.data, status: 'success' }
    } else throw ({ message: res.data.data.error, status: 'error' })
  }).catch(err => {
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function setSessionSecurity(data) {
  const { user, token, refreshToken, tokenSecurity, encryptedToken, roles, timeSession } = data

  if (user && token && refreshToken) {
    //Data user
    localStorage.setItem("name", user.name);
    localStorage.setItem("user", user.username);
    localStorage.setItem("documentNumber", user.documentNumber);
    localStorage.setItem("dataUser", await encryptStorage(JSON.stringify(user)));
    localStorage.setItem('role', roles);
    //Tokens
    localStorage.setItem("token", await encryptStorage(token));
    localStorage.setItem("tokenSecurity", await encryptStorage(tokenSecurity));
    localStorage.setItem("refreshToken", await encryptStorage(refreshToken));
    // localStorage.setItem("encryptedToken", encryptedToken);
    //Session
    localStorage.setItem('timeSesion', timeSession);
    return { status: 'success' }
  }
  else {
    localStorage.clear();
    return { status: 'error' }
  }
};

export async function setSigningCredentials(data) {
  const { username, password } = data

  if (username && password) {
    //Data user sign
    localStorage.setItem("signingUser", username);
    localStorage.setItem("signingPassword", await encryptAES(password));
    return { status: 'success' }
  }
  else {
    localStorage.clear();
    return { status: 'error' }
  }
};